import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationAddAlertEmails = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, emails }) => {
            return client.post(replaceParameters(ORGANIZATION.ALERTS.url, { organizationId: organizationId }), { emails: emails });
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddAlertEmails;